import { config } from '../dependencies';

export const STORAGE_KEY = 'restaurants';
